module.exports = __webpack_public_path__ + "static/01-d60311ebfb87b0476dba473113db274c.jpg";